import { Button } from "@mui/material";
import MyGuideIcon from "../MinhasGuias/MyGuideIcon";
import { sxButtonDetail, sxMyGuidesCard } from "../MinhasGuias/sxProps";
import './styles.css'
import { ActivationGuideCardProps } from "../../../interfaces/props/GuiasEAutorizacoes/ActivationGuideCardProps";
import { getProtocoloGuiaFutura } from "../../../services/MinhasGuiasService";
import { base64toBlob } from "../../../utils/Base64ToBlob";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import DefaultButton from "../../../components/Accessibility/DefaultButton";

function ActivationGuideCard(props: ActivationGuideCardProps) {

    const accessibility = useAccessibility();

    const handleClick = () => {
        props.handleGuideActivation(props.guide.idProtocSolicFutura)
    }

    const handleDetails = async () => {
        props.handleLoading(true);
        const pdf = await getProtocoloGuiaFutura(props.guide.idProtocSolicFutura, props.guide.idSolic);
        if (pdf !== null) {
            const blob = base64toBlob(pdf.split(',')[1]);
            const blobUrl = URL.createObjectURL(blob);
            props.handleLoading(false);
            window.open(blobUrl);
        }
    }

    return (
        <div className="my-guides-card-holder" tabIndex={0} style={{ ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
            <div className="my-guides-card-icon-holder">
                <MyGuideIcon />
            </div>
            <div className="my-guides-card-info-holder">
                <span className='my-guides-card-info' style={accessibility.textStyleAccessibility}><b>Protocolo:</b> {props.guide.idProtocSolicFutura}</span>
                <span className='my-guides-card-info' style={accessibility.textStyleAccessibility}><b>Solicitante:</b> {props.guide.solicitante}</span>
                <span className='my-guides-card-info' style={accessibility.textStyleAccessibility}><b>Data da Emissão:</b> {props.guide.dtCriacao}</span>
                <div className="activation-guide-card-button-holder-container">
                    <DefaultButton
                        variant="contained"
                        size="large"
                        onClick={handleClick}
                        style={accessibility.textStyleAccessibility}
                        sx={sxMyGuidesCard}
                        aria-label={`Ativar guia de protocolo ${props.guide.idProtocSolicFutura}`}
                    >
                        Ativar guia
                    </DefaultButton>
                    <DefaultButton
                        variant="text"
                        size="large"
                        onClick={handleDetails}
                        style={accessibility.textStyleAccessibility}
                        sx={sxButtonDetail}
                        aria-label={`Visualizar detalhes da guia de protocolo ${props.guide.idProtocSolicFutura}, solicitado por ${props.guide.solicitante} em ${props.guide.dtCriacao}`}
                    >
                        <>
                            Visualizar guia <FontAwesomeIcon icon={faChevronDown} />
                        </>
                    </DefaultButton>
                </div>
            </div>
        </div>
    )
}

export default ActivationGuideCard;